<template>
	<div class="pageArea">
		<Head2></Head2>
		<div class="mainAea">
			<div class="leftArea">
				 <div class="leftTitle">{{$t('components.my.leftTitle')}}</div>
				 <ul>
					 <li v-if="currentLanguage==='zh-CN'">
						 <div class="firstTitle">
							 <img src="../assets/images/orderIcon.png"/>
							 <div>{{$t('components.my.orderCenter')}}</div>
						 </div>
						 <ul class="secondTitle">
							<li :class="{active : type == 'ORDER' || type == 'ORDERDETAIL'}" @click="menuClick('ORDER')">{{$t('components.my.order_my')}}</li>
							<li :class="{active : type == 'AFTERSALE'}" @click="menuClick('AFTERSALE')">{{$t('components.my.aftersale')}}</li>
						 </ul>
					 </li>
<!-- 					 <li>
						 <div class="firstTitle">
							 <img src="../assets/images/huiIcon.png"/>
							 <div>优惠券</div>
						 </div>
						 <ul>
							<li>我的优惠券</li>
						 </ul>
					 </li> -->
					 <li v-if="currentLanguage==='zh-CN'">
						 <div class="firstTitle">
							 <img src="../assets/images/piao.png"/>
							 <div>{{$t('components.my.invoice')}}</div>
						 </div>
						 <ul>
							<li :class="{active : type == 'INVOICEINFO'}" @click="menuClick('INVOICEINFO')">{{$t('components.my.invoice_info')}}</li>
							<li :class="{active : type == 'APPLYINVOICE'}" @click="menuClick('APPLYINVOICE')">{{$t('components.my.apply_invoice')}}</li>
							<li :class="{active : type == 'INVOICE'}" @click="menuClick('INVOICE')">{{$t('components.my.my_invoice')}}</li>
						 </ul>
					 </li>
					 
					 <li v-if="currentLanguage==='zh-CN'">
						 <div class="firstTitle">
							 <img src="../assets/images/historyIcon.png"/>
							 <div>{{$t('components.my.history')}}</div>
						 </div>
						 <ul>
							<li :class="{active : type == 'HISTORY'}" @click="menuClick('HISTORY')">{{$t('components.my.browse_history')}}</li>
						 </ul>
					 </li>
					 <li v-if="currentLanguage==='zh-CN'">
						 <div class="firstTitle">
							 <img src="../assets/images/cang.png"/>
							 <div>{{$t('components.my.collection')}}</div>
						 </div>
						 <ul>
							<li :class="{active : type == 'COLLECTION'}" @click="menuClick('COLLECTION')">{{$t('components.my.my_collection')}}</li>
						 </ul>
					 </li>
					 <li v-if="currentLanguage==='zh-CN'">
						 <div class="firstTitle">
							 <img src="../assets/images/messageIcon.png"/>
							 <div>{{$t('components.my.message')}}</div>
						 </div>
						 <ul>
							<li :class="{active : type == 'MESSAGE'}" @click="menuClick('MESSAGE')">{{$t('components.my.messages_overview')}}</li>
						 </ul>
					 </li>
					 <li v-if="currentLanguage==='zh-CN'">
						 <div class="firstTitle">
							 <img src="../assets/images/pingIcon.png"/>
							 <div>{{$t('components.my.comment')}}</div>
						 </div>
						 <ul>
							<li :class="{active : type == 'UNCOMMENT'}" @click="menuClick('UNCOMMENT')">{{$t('components.my.uncomment')}}</li>
							<li :class="{active : type == 'COMMENTED'}" @click="menuClick('COMMENTED')">{{$t('components.my.commented')}}</li>
						 </ul>
					 </li>
					 <li>
						 <div class="firstTitle">
							 <img src="../assets/images/setIcon.png"/>
							 <div>{{$t('components.my.settings')}}</div>
						 </div>
						 <ul> 
							<li :class="{active : type == 'MYINFO'}" @click="menuClick('MYINFO')" >{{$t('components.my.my_info')}}</li>
							<li v-if="currentLanguage==='zh-CN'" :class="{active : type == 'COMPAYINFO'}" @click="menuClick('COMPAYINFO')" >{{$t('components.my.company_info')}}</li>
							<li v-if="currentLanguage==='zh-CN'" :class="{active : type == 'ADDRESSES'}" @click="menuClick('ADDRESSES')" >{{$t('components.my.addresses')}}</li>
						 </ul>
					 </li>
				 </ul>
				
			</div>
			<!-- 我的订单 -->
			<div class="rightAre" v-if="type=='ORDER'">
				<OrderVue @detailClick = 'showDetail' :tabIdx="order_state"></OrderVue>
			</div>
			<!-- 订单详情 -->
			<div  class="rightAre" v-if="type=='ORDERDETAIL'">
				<OrderDetailVue :id="orderId"></OrderDetailVue>				
			</div>
			<!-- 售后管理 -->
			<div class="rightArea" v-if="type =='AFTERSALE'">
				<AfterSaleVue></AfterSaleVue>
			</div>
			<!-- 我的收藏 -->
			<div class="rightArea" v-if="type =='COLLECTION'">
				<CollectionsVue></CollectionsVue>
			</div>
			<!-- 地址管理 -->
			<div class="rightArea" v-if="type == 'ADDRESSES'">
				<AddressesVue></AddressesVue>
			</div>
			<!-- 我的发票 -->
			<div class="rightAre" v-if="type == 'INVOICE'">
				<InvoiceVue></InvoiceVue>
			</div>
			<!-- 我的订单 -->
			<div class="rightArea" v-if="type == 'APPLYINVOICE'">
				<ApplyInvoiceVue></ApplyInvoiceVue>
			</div>
			<!-- 开票信息 -->
			<div class="rightArea" v-if="type == 'INVOICEINFO'">
				<InvoiceInfoVue></InvoiceInfoVue>
			</div>
			<!-- 企业信息 -->
			<div class="rightArea" v-if="type == 'COMPAYINFO'">
				<CompayInfoVue></CompayInfoVue>
			</div>
			<!--商品浏览记录  -->
			<div class="rightArea" v-if="type == 'HISTORY'">
				<HistoryVue></HistoryVue>
			</div>
			<!-- 待评价 已评价 -->
			<div class="rightArea" v-if="type == 'COMMENTED' ||  type == 'UNCOMMENT'">
				<CommentsVue :tabIdx="commmentType"></CommentsVue>
			</div>
			<!-- 消息一览  -->
			<div class="rightArea" v-if="type == 'MESSAGE'">
				<MessagesVue></MessagesVue>
			</div>
			<!-- 我的消息 -->
			<div class="rightArea" v-if="type == 'MYINFO'">
				<MyInfoVue></MyInfoVue>
			</div>
		</div>
		<Foot2></Foot2>
	</div>
	
</template>

<script>
	import Head2 from '../components/head2.vue';
	import Foot2 from '../components/foot2.vue';
	import OrderVue from './mypages/order.vue';
	import PaginationVue from '../components/pagination.vue';
	import OrderDetailVue  from './mypages/orderDetail.vue';
	import AfterSaleVue from './mypages/afterSale.vue';
	import CollectionsVue  from './mypages/collections.vue';
	import AddressesVue from './mypages/addresses.vue';
	import InvoiceVue from './mypages/invoices.vue';
	import ApplyInvoiceVue from './mypages/applyInvoice.vue';
	import InvoiceInfoVue from "./mypages/invoiceInfo.vue";
	import CompayInfoVue from './mypages/compayInfo.vue';
	import HistoryVue from './mypages/history.vue'
	import CommentsVue from './mypages/comments.vue'
	import MessagesVue from './mypages/messages.vue'
	import MyInfoVue from './mypages/myInfo.vue'
	
	export default{
		components:{
			Head2,
			Foot2,
			PaginationVue,
			OrderVue,
			OrderDetailVue,
			AfterSaleVue,
			CollectionsVue,
			AddressesVue,
			InvoiceVue,
			ApplyInvoiceVue,
			InvoiceInfoVue,
			CompayInfoVue,
			HistoryVue,
			CommentsVue,
			MessagesVue,
			MyInfoVue
		},
		data(){
			return{
				type: "MYINFO",
				orderId:0,
				order_state:0,
				currentLanguage:localStorage.getItem('locale-lang')||'zh-CN',
			}
		},
		created()
		{
			this.type = this.$route.query.type!=undefined?this.$route.query.type:this.type;
			this.order_state = this.$route.query.state!=undefined?this.$route.query.state:this.state;
			if(this.type=="UNCOMMENT")
			{
				this.commmentType=this.$route.query.tabIdx
			}
			this.checkLogin();
		},
		methods:{
			menuClick(v){				
				if(v=='UNCOMMENT'){
					this.commmentType = 0;
				} else if(v == 'COMMENTED'){
					this.commmentType = 1;
				} 
				
				this.type = v;
			},
			showDetail(message){
				this.orderId=message;
				this.type = 'ORDERDETAIL';
			},
			checkLogin(){
				this.$scUtil.checkLogin(this, res => {
				if (res) {

				}else
				{
					this.$router.push({name:'LoginVue'})
				}
			});
			}
		}
	}
</script>

<style scoped>
	.pageArea{
		background-color: #ebecee;
		display: flex;
		flex-direction: column;
		align-items: center;
	}
	
	.mainAea{
		width: 1200px;
		margin-top: 16px;
		margin-bottom: 17px;
		display: flex;
	}
	
	.leftArea{
		width: 233px;
		background-color: #fff;
		padding-bottom: 15px;
		margin-right: 15px;
	}
	
	.leftTitle{
		height: 50px;
		line-height: 50px;
		border-bottom: 1px solid #e2e2e2;
		font-size: 17px;
		text-align: center;
		margin-bottom: 15px;
	}
	
	ul li{
		list-style: none;
	}
	
	.firstTitle{
		padding-left: 60px;
		display: flex;
		align-items: center;
		height: 40px;
	}
	
	.firstTitle img{
		margin-right: 11px;
	}
	
	.firstTitle + ul li{
		height: 30px;
		padding-left:85px;
		font-size: 14px;
		color: #686868;
		cursor: pointer;
	}
	
	.firstTitle + ul li:hover,
	.firstTitle + ul li.active{
		color: #0380fe;
	}
</style>